function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, onUnmounted, watch } from "vue";
import { definePropType } from "@types-vue/props";
import { usePlanMarginChecking, usageType } from "./utils";
export default defineComponent({
    components: {},
    props: {
        costType: {
            type: definePropType(String),
            default: "durations",
            required: true
        },
        // 消耗次数、消耗时长数值
        costNum: {
            type: definePropType(null),
            required: true
        },
        biz_type: {
            type: definePropType(String),
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        usageType: {
            type: String,
            default: usageType.video_credits
        },
        // 自动更新间隔
        interval: {
            type: Number
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        // 消耗、余额
        var postdata = computed(function() {
            return {
                biz_type: props.biz_type,
                costType: props.costType,
                costNum: props.costNum,
                usage_type: props.usageType
            };
        });
        var result = usePlanMarginChecking(postdata);
        var update = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return result.value.update(postdata.value);
                        case 2:
                            emit("cost-change", {
                                cost: result.value.cost,
                                balance: result.value.balance
                            });
                        case 3:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function update() {
                return _ref.apply(this, arguments);
            };
        }();
        watch(function() {
            return props.costNum;
        }, function() {
            update();
        }, {
            immediate: true
        });
        var timer = null;
        if (props.interval) {
            timer = setInterval(function() {
                update();
            }, props.interval);
        }
        onUnmounted(function() {
            if (timer) {
                clearInterval(timer);
                timer = null;
            }
        });
        return {
            result: result,
            update: update
        };
    }
});
